import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_DOCUMENT} from '../../constants';

export default {
  id: 'ARCHIVE',
  title: 'Comment consulter mes archives ?',
  description: '',
  categories: [CONTENT_CATEGORY_DOCUMENT],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Tout document déposé reste accessible, même après son expiration.'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'A partir de l’onglet « documents », cliquez sur Consulter mes archives'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_ARCHIVE/FR_ARCHIVE.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Vous accédez alors à vos archives et pouvez les télécharger'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Ces archives sont stockées pour une durée de 15 ans et sont accessibles pour vos clients également.'
  }]
};
